import { dispatchExitEvent } from '@epilot/journey-logic-commons'
import { memo, useMemo } from 'react'

import { useAppManagerContext } from '../hooks/useAppManagerContext'
import { useAppStoreSelector } from '../hooks/useAppStoreSelector'
import { selectOriginalJourney } from '../store/selectors/config'
import { selectAppError } from '../store/selectors/runtime'
import { APP_ERROR } from '../store/types/enums'

import { ExpiredJourneyTokenError } from './ExpiredJourneyTokenError'
import { JourneyAlreadySubmittedError } from './JourneyAlreadySubmittedError'
import { JourneyNotFoundError } from './JourneyNotFoundError'
import { publishCloseJourneyMessage } from './JourneyPage/embedJourneyPublishers'

/**
 * Renders an error screen based on the current App error, which is considered an unrecoverable error.
 *
 * WARNING: Renders an error by default, please check for the existance of an error before rendering {@link AppError}.
 */
export const AppError = memo(() => {
  const journey = useAppStoreSelector(selectOriginalJourney)
  const error = useAppStoreSelector(selectAppError)
  const { appParams } = useAppManagerContext()

  const ErrorComponent = useMemo(() => {
    switch (error) {
      case APP_ERROR.JOURNEY_TOKEN_EXPIRED:
        return ExpiredJourneyTokenError
      case APP_ERROR.JOURNEY_NONCE:
        return JourneyAlreadySubmittedError
      case APP_ERROR.JOURNEY_NOT_FOUND:
      default:
        return JourneyNotFoundError
    }
  }, [error])

  return (
    <ErrorComponent
      embedMode={appParams.mode}
      isEmbedded={appParams.isEmbedded}
      onClose={() => {
        dispatchExitEvent()
        publishCloseJourneyMessage({
          journeyId: journey?.journeyId,
          isDirty: false
        })
      }}
    />
  )
})

AppError.displayName = 'AppError'
